import TablaUtil from '../utils/tabla.js'
import { FILTROS_REPORTE } from '@/constantes/reportes'
import { PAGO_BASE_OBJ } from '@/constantes/casos/index.js'
import {formatoMonto} from '@/constantes/helpers'
import Vue from 'vue'
import { obtenerTotalPagosRealizados } from '@/constantes/saldo/index.js'

const FILTROS_PARAMETRO = {
    filtros:FILTROS_REPORTE
}

const obtenerPagosDeTickets = (tickets, ticketsVentaMostrador) => {

    const lista = []
    const totales = {}

    const obtenerPago = (pago, ticket) => {

        if(!totales[ticket.id_numerico]){
            totales[ticket.id_numerico] = obtenerTotalPagosRealizados(ticket.pagos_realizados)
        }

        return {
            ...pago,
            ticket:ticket.id_numerico,
            id_propietario:ticket.id_propietario,
            total:totales[ticket.id_numerico],
        }
    }

    for(const i in tickets){
        const item = tickets[i]
        item.pagos_realizados.forEach(e=> lista.push(obtenerPago(e,item)))
    }

    for(const i in ticketsVentaMostrador){
        const item = ticketsVentaMostrador[i]
        item.pagos_realizados.forEach(e=> lista.push(obtenerPago(e,item)))
    }

    return lista

}

const obtenerCabeceraTabla = () => {
    return [
        [
            'Fecha','Propietario','Ticket','Paciente','Efectivo','Débito/tipo','Crédito/tipo',
            'Cheque','Transfer.','Depósito.','Vales','Anticipos','Otro','Total',
        ]
    ]
}
/**
 * @param {PAGO_BASE_OBJ[]} pagos 
 */
const obtenerCuerpoTabla = (pagos) => {

    const lista = []
    const obtenerMonto = (e, tipo) => formatoMonto(e.forma_pago===tipo ? e.monto : 0,'$')

    pagos.forEach(e => {

        lista.push([
            e.fecha,
            Vue.filter('nombrePropietario')(e.id_propietario),
            e.ticket,
            'N/A',
            obtenerMonto(e,'Efectivo'),
            obtenerMonto(e,'T. Débito'),
            obtenerMonto(e,'T. Crédito'),
            obtenerMonto(e,'Cheque'),
            obtenerMonto(e,'Transferencia'),
            obtenerMonto(e,'Depósito'),
            obtenerMonto(e,'Vales'),
            obtenerMonto(e,'Anticipos'),
            obtenerMonto(e,'Otro'),
            formatoMonto(e.total,'$'),
        ])

    })

    return lista

}

/**
 * 
 * @param {FILTROS_PARAMETRO} filtrosParametro 
 */
 const generarTabla = (filtrosParametro) => {

    const {doc, filtros, tickets, ticketsVentaMostrador} = filtrosParametro
    const pagos = obtenerPagosDeTickets(tickets,ticketsVentaMostrador)
    const head = obtenerCabeceraTabla()
    const body = obtenerCuerpoTabla(pagos)

    TablaUtil.crearTablaPersonalizada({doc,startY:190,body,head})
    
}

export default {
    generarTabla
}


// WEBPACK FOOTER //
// ./src/vistas/Reportes2/reportes/pagos.js